import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Flex,
  Text,
  Icon,
  useColorModeValue,
} from "@chakra-ui/react";

import React, { useMemo, useEffect, useState } from "react";
import {
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table";
import { useHistory } from "react-router-dom";
import AuthService from "services/auth.services.js";
import ApiService from "services/api.js";
import UtilService from "services/util.service.js";
// Custom components
import Card from "components/card/Card";
import Menu from "components/menu/MainMenu";
import Pagination from "components/dataDispaly/Pagination";
import HeaderEndOfDayComparison from "./HeaderEndOfDayComparison";

// Assets
import { MdCheckCircle, MdCancel } from "react-icons/md";
export default function EndOfDayData(props) {
  // custom variable
  let DateFrom = UtilService.dateFrom;
  let DateTo = UtilService.dateTo;

  const history = useHistory();

  // Use state variable
  const { columnsData } = props;
  const [data, setData] = useState([]);
  const [dataPage, setDataPage] = useState([]);
  const [dataPageSize, setDataPageSize] = useState(5);
  const [loading, setLoading] = useState(true);
  const [inputDateFrom, setDateFrom] = useState(DateFrom);
  const [inputDateTo, setDateTo] = useState(DateTo);
  const [inputBranch, setInputBranch] = useState("");
  const [inputCheckbox, setCheckbox] = useState(true);
  const [urlExcel, setUrlExcel] = useState("");

  // ref variable
  const skipPageResetRef = React.useRef();
  // memo variable
  const columns = useMemo(() => columnsData, [columnsData]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0, pageCount: dataPage },
      manualPagination: true,
      pageCount: dataPage,
      autoResetPage: !skipPageResetRef.current,
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  // useEffect(() => {
  //   setLoading(true);
  //   try {

  //     const fetchData = async () => {
  //     let ass = await ApiService.options()
 //     // console.log("fgfg",ass)
  //       try {
  //         skipPageResetRef.current = true;
  //         let response = await ApiService.client.get(
  //           `/dataCore/getDataEODGroupBy/${
  //             pageIndex + 1
  //           }/${dataPageSize}/${inputBranch === "" ? ApiService.firstBranch() : inputBranch}/${inputCheckbox}/${inputDateFrom}/${inputDateTo}`,
  //           await ApiService.options()
  //         );
  //         setDataPage(response.data["total_halaman"]);
  //         setPageSize(dataPageSize);
  //         setData(response.data.data);
  //         skipPageResetRef.current = false;
  //       } catch (error) {
 //         console.log(error.response.status)
  //         if (error.response.status === 401) {
  //           // AuthService.logout().then(
  //           //   () => {
 //           //     console.log("Success Logout");
  //           //   },
  //           //   (error) => {
  //           //     (error.response &&
  //           //       error.response.data &&
  //           //       error.response.data.message) ||
  //           //       error.message ||
  //           //       error.toString();
  //           //   }
  //           // );
  //           // history.push("/auth/sign-in");
  //         }

 //         console.log("error ni", error.response.status);
  //       }
  //     };
  //     setUrlExcel(ApiService.excel+`/dataCore/exportAllDataEODGroupBy/${inputBranch === "" ? "all" : inputBranch}/${inputCheckbox}/${inputDateFrom}/${inputDateTo}`)
  //     fetchData();
  //   } catch (error) {
  //     if (error.response.status === 401) {
  //       history.push("/auth/sign-in");
  //     }
 //     console.log(error);
  //   }
  // }, [
  //   pageIndex,
  //   dataPage,
  //   dataPageSize,
  //   pageSize,
  //   inputBranch,
  //   inputDateFrom,
  //   inputDateTo,
  //   inputCheckbox,
  // ]);

  //Branch Data
  const options = ApiService.optionsBranch()

  useEffect(() => {
    // Create mounting flag
    let isMounted = true;

    const fetchData = async () => {
      if (isMounted) {
        setLoading(true);
      }

      try {
        skipPageResetRef.current = true;
        const requestOptions = await ApiService.options();
        let response = await ApiService.client.get('/dataEOD/getDataEODGroupBy', {
          params: {
            page: pageIndex + 1,
            limit: dataPageSize,
            branch_ids: inputBranch === "" ? options?.map(data => data.id).join(',') : inputBranch,
            //branch_name: inputBranchName === "" ? "" : inputBranchName,
            use_having: inputCheckbox,
            from_order_date: inputDateFrom,
            to_order_date: inputDateTo
          }, ...requestOptions
        // }, await ApiService.options());
        });

        // Only update state if component is still mounted
        if (isMounted) {
          setDataPage(response.data["total_halaman"]);
          setPageSize(dataPageSize);
          setData(response.data.data);
          skipPageResetRef.current = false;
        }
      } catch (error) {
        if (isMounted) {
          if (error.response) {
            if (error.response.status === 401) {
              // console.log("Unauthorized access - 401 error");

              // Handle unauthorized access
              // history.push("/auth/sign-in");
              AuthService.logout().then(
                () => {
                  // console.log("Success Logout");
                  history.push("/auth/sign-in");
                },
                (error) => {
                  (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                    error.message ||
                    error.toString();
                }
              );
            }
            // console.log("Server error:", error.response.status, error.response.data);
          } else if (error.request) {
            // console.log("Network error - no response received:", error.request);
          } else {
            // console.log("Error:", error.message);
          }
        }
      } finally {
        // Only update loading state if component is still mounted
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    // Set URL Excel only if component is mounted
    if (isMounted) {
      setUrlExcel(ApiService.excel + `/dataEOD/exportAllDataEODGroupBy`, {
        params: {
          page: pageIndex + 1,
          limit: dataPageSize,
          branch_ids: inputBranch === "" ? options?.map(data => data.id).join(',') : inputBranch,
          //branch_name: inputBranchName === "" ? "" : inputBranchName,
          use_having: inputCheckbox,
          from_order_date: inputDateFrom,
          to_order_date: inputDateTo
        }
      });
    }
    fetchData();

    // Cleanup function to prevent memory leaks
    return () => {
      isMounted = false;
    };
  }, [
    pageIndex,
    dataPage,
    dataPageSize,
    pageSize,
    inputBranch,
    inputDateFrom,
    inputDateTo,
    inputCheckbox,
  ]);




  const textColor = useColorModeValue("secondaryGray.900", "white");
  const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");

 // console.log("ini data lho", data);

  return (
    <Card
      direction={{ base: "column", sm: "row" }}
      w="100%"
      px="0px"
      overflowX={{ sm: "scroll", md: "scroll", lg: "scroll" }}
    >
      <Flex px="25px" justify="space-between" mb="20px" align="center">
        <Text
          color={textColor}
          fontSize="22px"
          fontWeight="700"
          lineHeight="100%"
        >
          End Of Days Comparison
        </Text>
        <Menu urlExcel={urlExcel} />
      </Flex>

      <HeaderEndOfDayComparison
        inputDateFrom={inputDateFrom}
        inputDateTo={inputDateTo}
        inputBranch={inputBranch}
        inputCheckbox={inputCheckbox}
        setDateFrom={setDateFrom}
        setDateTo={setDateTo}
        setInputBranch={setInputBranch}
        setCheckbox={setCheckbox}
      />

      <Table {...getTableProps()} variant="simple" color="gray.500" mb="24px">
        <Thead>
          {headerGroups.map((headerGroup, index) => (
            <Tr {...headerGroup.getHeaderGroupProps()} key={index}>
              {headerGroup.headers.map((column, index) => (
                <Th
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                  pe="10px"
                  key={index}
                  borderColor={borderColor}
                >
                  <Flex
                    justify="space-between"
                    align="center"
                    fontSize={{ sm: "10px", lg: "12px" }}
                    color="gray.400"
                  >
                    {column.render("Header")}
                  </Flex>
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody {...getTableBodyProps()}>
          {page.map((row, index) => {
            prepareRow(row);
            return (
              <Tr {...row.getRowProps()} key={index}>
                {row.cells.map((cell, index) => {
                  let data = "";
                  if (cell.column.Header === "ORDER DATE") {
                    data = (
                      <Text color={textColor} fontSize="sm" fontWeight="700">
                        {cell.value}
                      </Text>
                    );
                  } else if (cell.column.Header === "BRANCH ID") {
                    data = (
                      <Text color={textColor} fontSize="sm" fontWeight="700">
                        {cell.value}
                      </Text>
                    );
                  } else if (cell.column.Header === "STATUS DATA OK") {
                    data = (
                      <Flex align='center'>
                        <Icon
                          w='24px'
                          h='24px'
                          me='5px'
                          color={
                            cell.row.cells[3].value === cell.row.cells[5].value && cell.row.cells[4].value === cell.row.cells[6].value
                              ? "green.500"
                              : cell.row.cells[3].value !== cell.row.cells[5].value || cell.row.cells[4].value !== cell.row.cells[6].value
                                ? "red.500"
                                : null
                          }
                          as={
                            cell.row.cells[3].value === cell.row.cells[5].value && cell.row.cells[4].value === cell.row.cells[6].value
                              ? MdCheckCircle
                              : cell.row.cells[4].value === cell.row.cells[6].value ? MdCheckCircle : cell.row.cells[3].value !== cell.row.cells[5].value
                                ? MdCancel
                                : MdCancel
                          }
                        />
                        <Text color={textColor} fontSize='sm' fontWeight='700'>
                          {cell.row.cells[3].value === cell.row.cells[5].value && cell.row.cells[4].value === cell.row.cells[6].value ? "Sama" : "Tidak Sama"}
                        </Text>
                      </Flex>
                    );
                  } else if (cell.column.Header === "DAY BEGIN") {
                    data = (
                      <Text color={textColor} fontSize="sm" fontWeight="700">
                        {cell.value}
                      </Text>
                    );
                  } else if (cell.column.Header === "DAY END") {
                    data = (
                      <Text color={textColor} fontSize="sm" fontWeight="700">
                        {cell.value}
                      </Text>
                    );
                  } else if (cell.column.Header === "TOTAL SALES RAW") {
                    data = (
                      <Text color={textColor} fontSize="sm" fontWeight="700">
                        {cell.value}
                      </Text>
                    );
                  } else if (cell.column.Header === "COUNT BILL RAW") {
                    data = (
                      <Text color={textColor} fontSize="sm" fontWeight="700">
                        {cell.value}
                      </Text>
                    );
                  } else if (cell.column.Header === "TOTAL SALES OK") {
                    data = (
                      <Text color={textColor} fontSize="sm" fontWeight="700">
                        {cell.value}
                      </Text>
                    );
                  } else if (cell.column.Header === "COUNT BILL OK") {
                    data = (
                      <Text color={textColor} fontSize="sm" fontWeight="700">
                        {cell.value}
                      </Text>
                    );
                  } else if (cell.column.Header === "TOTAL CANCEL BILL") {
                    data = (
                      <Text color={textColor} fontSize="sm" fontWeight="700">
                        {cell.value}
                      </Text>
                    );
                  } else if (cell.column.Header === "COUNT CANCEL BILL") {
                    data = (
                      <Text color={textColor} fontSize="sm" fontWeight="700">
                        {cell.value}
                      </Text>
                    );
                  } else if (cell.column.Header === "TOTAL CANCEL ITEM") {
                    data = (
                      <Text color={textColor} fontSize="sm" fontWeight="700">
                        {cell.value}
                      </Text>
                    );
                  } else if (cell.column.Header === "COUNT CANCEL ITEM") {
                    data = (
                      <Text color={textColor} fontSize="sm" fontWeight="700">
                        {cell.value}
                      </Text>
                    );
                  } else if (cell.column.Header === "TOTAL SALES CXM") {
                    data = (
                      <Text color={textColor} fontSize="sm" fontWeight="700">
                        {cell.value}
                      </Text>
                    );
                  } else if (cell.column.Header === "COUNT BILL CXM") {
                    data = (
                      <Text color={textColor} fontSize="sm" fontWeight="700">
                        {cell.value}
                      </Text>
                    );
                  }
                  return (
                    <Td
                      {...cell.getCellProps()}
                      key={index}
                      fontSize={{ sm: "14px" }}
                      minW={{ sm: "150px", md: "200px", lg: "auto" }}
                      borderColor="transparent"
                    >
                      {data}
                    </Td>
                  );
                })}
              </Tr>
            );
          })}
        </Tbody>
      </Table>
      <Pagination canNextPage={canNextPage} nextPage={nextPage} canPreviousPage={canPreviousPage}
        previousPage={previousPage} pageIndex={pageIndex} pageOptions={pageOptions}
        gotoPage={gotoPage} pageSize={pageSize} setDataPageSize={setDataPageSize} pageCount={pageCount} />
    </Card>
  );
}
